import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useNavigate } from "react-router-dom";
import { routes, screens } from "../../../config/routes";
import { Tab } from "../../../interfaces/api/congresses";
import GridItem from "../../../components/gridItem";
import GridItemSkeleton from "../../../components/gridItem/skeleton";

interface GridItemData extends Tab {
  imageUri: string;
}

const localImages: Record<string, string> = {
  "Medical Updates": require("../../../assets/images/tabs/medicalUpdates.png"),
  Guidelines: require("../../../assets/images/tabs/guidelines.png"),
  "Treatment Options": require("../../../assets/images/tabs/treatmentOptions.png"),
  Congresses: require("../../../assets/images/tabs/congresses.png"),
  Media: require("../../../assets/images/tabs/media.png"),
  "Diagnostic Tools": require("../../../assets/images/tabs/diagnosticTools.png"),
  "Latest Innovations": require("../../../assets/images/tabs/latestInnovations.png"),
  "Laboratory Values": require("../../../assets/images/tabs/labValues.png"),
  "Medical Calculators": require("../../../assets/images/tabs/medicalCalculators.png"),
};

const defaultImage = require("../../../assets/images/tabs/medicalUpdates.png");

/**
 * Congresses main screen for displaying tabs as grid items.
 * @returns {JSX.Element} The Congresses screen component.
 */
const Congresses = () => {
  const removedItems = [5, 9, 10, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  const tabs = useSelector((state: RootState) => state.auth.tabs);
  const isLoadingTabs = useSelector(
    (state: RootState) => state.auth.isLoadingTabs,
  );
  const navigate = useNavigate();

  const gridItems: GridItemData[] = (tabs || [])
    .filter((item: Tab) => !removedItems.includes(item.id))
    .map((filter: Tab) => ({
      ...filter,
      imageUri:
        localImages[filter.tab_name] || filter.image_url || defaultImage,
    }));

  const handleCardClick = (item: GridItemData) => {
    if (item.tab_name === "Medical Calculators") {
      navigate(screens.medicalCalculators);
    } else if (item.tab_name === "Laboratory Values") {
      navigate(routes.medical.laboratoryValues);
    } else {
      const formattedName = item.tab_name.toLowerCase().replace(/\s+/g, "-");
      navigate(`/tabs/${formattedName}-${item.id}`);
    }
  };

  return (
    <div className="py-4">
      <div className="mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
          {isLoadingTabs
            ? Array.from({ length: 9 }).map((_, index) => (
                <GridItemSkeleton key={index} />
              ))
            : gridItems.map((item) => (
                <GridItem
                  key={item.id}
                  id={item.id}
                  tab_name={item.tab_name}
                  imageUri={item.imageUri}
                  onClick={() => handleCardClick(item)}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default Congresses;
